export default __webpack_public_path__ + "static/dust2-875844976039175caa19687ea627acb6.png";